import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class MeterTableHeader extends Component
{
  static Layout = [
      { column: "utility", width: 2 },
      { column: "serialNumber", width: 3, name: "Serial Number" },
      { column: "reference" },
      { column: "meterType", name: "Type"  },
      { column: "meterDescription", width: 2, name: "Meter Description" },
      { column: "msStatus", width: 2, name:"Status" },
      { column: "supplyAddress", width: 2, name:"Supply Address" },
      { column: "connectionType", width: 2, name:"Connection Type" },
      { column: "empty", width: 2 }
  ];

  render() {
      return (
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={MeterTableHeader.Layout}/>
      )
  }
}